module.exports = __webpack_public_path__ + "img/报名.2a3bedcd.png";